import { Link } from 'react-router-dom'

interface Props {
  to: string
  label: string
  icon?: any
}

const FooterItem = ({ icon: Icon, to, label }: Props) => {
  return (
    <div
      key={label}
      className='flex items-center text-white heading-2 gap-[5px] hover:gap-[10px] transition'
    >
      {Icon && <Icon />}
      <Link to={to}>{label}</Link>
    </div>
  )
}

export default FooterItem
